'use client'

import { PUBLIC_THERAPISTS_PAGE_SLUG } from '@/legacy-src/constants/locale.constants'
import { PSYCHIATRY_INTRO_SERVICE_ID } from '@/legacy-src/constants/service.constants'
import useServices from '@/legacy-src/hooks/useServices'
import { SERVICES_TYPE } from '@/legacy-src/redux/DiagnosisRedux'
import type { ServiceType } from '@/legacy-src/types/GeneralStateType'

import { useHeaderServicePages } from '@/src/domains/header/hooks/useHeaderServicePages'
import { getLocalisedHref } from '@/src/domains/next-roots/utils/getLocalisedHref'

const getServiceHref = (serviceId: number, customServicePages: Record<number, string>) => {
  const customServicePage = customServicePages[serviceId]

  if (customServicePage !== undefined) {
    return getLocalisedHref('/[slug]', { slug: customServicePage })
  }

  if (serviceId === PSYCHIATRY_INTRO_SERVICE_ID) {
    return '/psychiatrie'
  }

  return `/${PUBLIC_THERAPISTS_PAGE_SLUG}?service=${serviceId}`
}

const getServiceMenuItems = (services: ServiceType[], customServicePages: Record<number, string>) =>
  services
    .filter(({ type, visible }) => type !== SERVICES_TYPE.HIDDEN && type !== SERVICES_TYPE.COUNSELLING && visible)
    .map((service) => ({
      href: getServiceHref(service.id, customServicePages),
      title: service.name,
    }))

export const useHeaderServiceMenuItems = () => {
  const { services } = useServices()
  const { data: customServicePages } = useHeaderServicePages()

  return getServiceMenuItems(services ?? [], customServicePages)
}
